import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-ep-dropdown",
  templateUrl: "./ep-dropdown.component.html",
  styleUrls: ["./ep-dropdown.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EpDropdownComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class EpDropdownComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() options: any[];
  @Input() placeholder = "";
  @Input() disabled: boolean;
  @Input() searchName = "";

  @Output() passClick = new EventEmitter<string>(); // pass a string
  @Output() selectedName = new EventEmitter<{
    propertyName: string;
    propertyValue: string;
  }>(); // pass a obj

  showDropDown = false;

  detectInput(event: any) {
    // ods-autosuggest passes the selected value directly in event.detail
    const value = event.detail || event.target?.value || "";

    this.searchName = value;

    if (this.searchName.length === 0) {
      this.onChange(this.searchName);
      this.selectedName.emit({ propertyName: this.id, propertyValue: "" });
    } else {
      // Emit the value regardless - the parent will validate
      this.onChange(this.searchName);
      this.selectedName.emit({
        propertyName: this.id,
        propertyValue: this.searchName,
      });
    }
  }

  show() {
    this.passClick.emit(this.id);
    this.showDropDown = true;
  }

  hide() {
    this.onTouched();
    // For ods-autosuggest, we don't need the dropdown toggle logic
  }

  selectName(item: string) {
    if (this.options) {
      this.searchName = item;
      this.onChange(this.searchName);
      this.selectedName.emit({ propertyName: this.id, propertyValue: item });
      this.showDropDown = false;
    }
  }

  // tslint:disable
  onChange = (value) => {};
  onTouched = () => {};
  // tslint:enable

  writeValue(value) {
    this.searchName = value ? value : ""; // reactive form 给search设初值
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
